import React, { useState } from "react";
import {
  requestRaffleClaim,
  requestRafflePopupSeen,
} from "@/apps/raffle/services/raffleApi";
import { useRaffleDataStore } from "@/apps/raffle/store/raffleDataStore";
import { useStartupParamsStore } from "@/store/startupParams";
import { WonPrizeModal } from "@/apps/raffle/pages/RafflePage/WonPrizeModal";
import { ResultsPopupModal } from "./ResultsPopupModal";

type WonPopupModalProps = {
  isSubmitting: boolean;
  onClaim: () => void;
};

const WonPopupModal = ({
  isSubmitting,
  onClaim,
}: WonPopupModalProps) => {
  const popup = useRaffleDataStore((state) => state.bonusWinPopup);

  if (popup?.type !== "won") {
    return null;
  }

  return (
    <WonPrizeModal
      prizeAmount={popup.prize_amount}
      rides={popup.rides}
      winProbability={popup.win_probability}
      isOpen
      isClaiming={isSubmitting}
      onClose={onClaim}
      onClaimPrize={onClaim}
    />
  );
};

export const BonusPopupController = () => {
  const yandexId = useStartupParamsStore((state) => state.auth.yandexId);
  const popup = useRaffleDataStore((state) => state.bonusWinPopup);
  const clearBonusWinPopup = useRaffleDataStore(
    (state) => state.clearBonusWinPopup
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!popup || !yandexId) {
    return null;
  }

  const completePopup = async (request: () => Promise<unknown>) => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await request();
    } catch (error) {
      console.error("Failed to dismiss bonus popup", error);
    } finally {
      clearBonusWinPopup();
      setIsSubmitting(false);
    }
  };

  if (popup.type === "results") {
    return (
      <ResultsPopupModal
        isSubmitting={isSubmitting}
        onDismiss={() =>
          completePopup(() => requestRafflePopupSeen(yandexId, popup.draw_id))
        }
      />
    );
  }

  return (
    <WonPopupModal
      isSubmitting={isSubmitting}
      onClaim={() => completePopup(() => requestRaffleClaim(yandexId))}
    />
  );
};
